import { DimensionalSelectField } from './dimensional-select-field'
import { TooltipProps } from '../../../../../../../../shared/components/tooltip/tooltip'

import './lumber-dimensions-select-dropdown.scss'

export enum AvailableFields {
    thickness = 'thickness',
    width = 'width',
    length = 'length',
}

export interface ILumberDimensionsSelectDropdownProps {
    fieldName: string
    fieldsData: {
        [AvailableFields.thickness]?: string
        [AvailableFields.width]?: string
        [AvailableFields.length]?: string
    }
    selectionValues: {
        [AvailableFields.thickness]: {
            enumNames: string[]
            enum: string[]
        }
        [AvailableFields.width]: {
            enumNames: string[]
            enum: string[]
        }
        [AvailableFields.length]: {
            enumNames: string[]
            enum: string[]
        }
    }
    onFieldChange: (value: string, fieldName: AvailableFields) => void
    shouldIncludeThickness?: boolean
    shouldIncludeWidth?: boolean
    shouldIncludeLength: boolean
    isLengthFieldDisabled?: boolean
    tooltips?: {
        thickness: TooltipProps['tooltipData']
        width: TooltipProps['tooltipData']
        length: TooltipProps['tooltipData']
    }
    placeholders?: {
        thickness: string
        width: string
        length: string
    }
    requiredDimensions?: {
        thickness?: boolean
        width?: boolean
        length?: boolean
    }
}

export function LumberDimensionsSelectDropDown({
    fieldName,
    fieldsData,
    onFieldChange,
    selectionValues,
    shouldIncludeThickness = true,
    shouldIncludeWidth,
    shouldIncludeLength,
    isLengthFieldDisabled = true,
    tooltips = undefined,
    placeholders = {
        thickness: 'T',
        width: 'W',
        length: 'L',
    },
    requiredDimensions = {
        thickness: false,
        width: false,
        length: false,
    },
}: ILumberDimensionsSelectDropdownProps) {
    return (
        <div id="LumberDimensionFieldsWrapper">
            <div className="lumber-dimensions-field">
                <div className="fields-wrapper" data-testid={fieldName}>
                    {shouldIncludeThickness && (
                        <DimensionalSelectField
                            fieldFor={AvailableFields.thickness}
                            onFieldChange={onFieldChange}
                            options={selectionValues[AvailableFields.thickness]}
                            placeholder={placeholders.thickness}
                            required={requiredDimensions.thickness}
                            tooltipData={tooltips?.thickness}
                            value={fieldsData[AvailableFields.thickness]}
                        />
                    )}

                    {shouldIncludeThickness && shouldIncludeWidth && <span className="divider">X</span>}

                    {shouldIncludeWidth && (
                        <DimensionalSelectField
                            fieldFor={AvailableFields.width}
                            onFieldChange={onFieldChange}
                            options={selectionValues[AvailableFields.width]}
                            placeholder={placeholders.width}
                            required={requiredDimensions.width}
                            tooltipData={tooltips?.width}
                            value={fieldsData[AvailableFields.width]}
                        />
                    )}

                    {shouldIncludeWidth && shouldIncludeLength && <span className="divider">X</span>}

                    {shouldIncludeLength && (
                        <DimensionalSelectField
                            disabled={isLengthFieldDisabled}
                            fieldFor={AvailableFields.length}
                            onFieldChange={onFieldChange}
                            options={selectionValues[AvailableFields.length]}
                            placeholder={placeholders.length}
                            required={requiredDimensions.length}
                            tooltipData={tooltips?.length}
                            value={fieldsData[AvailableFields.length]}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
